/**
 * 인증 토큰을 네이티브(Flutter)와 동기화.
 *
 * 네이티브는 auth_token / is_authenticated 를 SharedPreferences에 저장하고,
 * 앱 시작 시 그 값으로 초기 URL(로그인/홈)을 정하고 토큰을 localStorage에 재주입한다.
 * 따라서 웹에서 로그인/로그아웃할 때 네이티브에도 알려야 재시작 후 상태가 유지된다.
 *  - 로그인: token 전달 → 네이티브 is_authenticated=true
 *  - 로그아웃: null/'' 전달 → 네이티브 토큰 삭제 + is_authenticated=false
 *    (안 하면 네이티브가 옛 토큰을 재주입해 "로그아웃 후 재시작 시 다시 로그인" 버그)
 *
 * 네이티브 핸들러: webview_page.dart 의 action:'syncAuthToken'.
 */
export const syncAuthTokenToNative = (token: string | null): void => {
  const channel = (window as any).FlutterChannel
  if (!channel || typeof channel.postMessage !== 'function') return
  try {
    channel.postMessage(
      JSON.stringify({
        action: 'syncAuthToken',
        token: token ?? '',
      })
    )
  } catch {
    // 브리지 없으면 무시 (웹 환경)
  }
}
